// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var NotificationType;
(function (NotificationType) {
    NotificationType["UNKNOWN"] = "UNKNOWN";
    NotificationType["PHONE_CALL"] = "PHONE_CALL";
    NotificationType["SMS"] = "SMS";
    NotificationType["FOLLOW_UP"] = "FOLLOW_UP";
    NotificationType["VOICEMAIL"] = "VOICEMAIL";
    NotificationType["MISSED_CALL"] = "MISSED_CALL";
    NotificationType["FAX"] = "FAX";
    NotificationType["SCHEDULE_REQUEST"] = "SCHEDULE_REQUEST";
    NotificationType["CHAT_MESSAGE"] = "CHAT_MESSAGE";
    NotificationType["SMS_TAG"] = "SMS_TAG";
    NotificationType["REVIEWS"] = "REVIEWS";
    NotificationType["REVIEW_COMMENT"] = "REVIEW_COMMENT";
    NotificationType["FORMS"] = "FORMS";
    NotificationType["VOICEMAIL_TRANSCRIPTION"] = "VOICEMAIL_TRANSCRIPTION";
    NotificationType["PHONE_CALL_V2"] = "PHONE_CALL_V2";
    NotificationType["CALL_QUEUES"] = "CALL_QUEUES";
    NotificationType["SMS_PAUSE_SCHEDULED_THREAD"] = "SMS_PAUSE_SCHEDULED_THREAD";
    NotificationType["SMS_TAG_V2"] = "SMS_TAG_V2";
    NotificationType["PAYMENTS"] = "PAYMENTS";
    NotificationType["MANUAL_MESSAGE_CONSENT"] = "MANUAL_MESSAGE_CONSENT";
    NotificationType["TASK"] = "TASK";
    NotificationType["SMS_MANUAL_SCHEDULED"] = "SMS_MANUAL_SCHEDULED";
    NotificationType["FAX_READ_STATUS_CHANGE"] = "FAX_READ_STATUS_CHANGE";
    NotificationType["FAX_TAG"] = "FAX_TAG";
    NotificationType["DRAFT_COUNT_CHANGE"] = "DRAFT_COUNT_CHANGE";
    NotificationType["FAX_COUNT_CHANGE"] = "FAX_COUNT_CHANGE";
    NotificationType["CALL_RECORD"] = "CALL_RECORD";
    NotificationType["VOICEMAIL_TAG"] = "VOICEMAIL_TAG";
    NotificationType["CALL_RECORD_TAG"] = "CALL_RECORD_TAG";
    NotificationType["DEVICE_CONNECTION"] = "DEVICE_CONNECTION";
    NotificationType["TEAM_CHAT"] = "TEAM_CHAT";
    NotificationType["ORG_USER_PRESENCE"] = "ORG_USER_PRESENCE";
    NotificationType["VOICEMAIL_MESSAGE"] = "VOICEMAIL_MESSAGE";
    NotificationType["APPOINTMENT_CHANGED"] = "APPOINTMENT_CHANGED";
    NotificationType["SCHEDULE_CHANGED"] = "SCHEDULE_CHANGED";
    NotificationType["USER_PREFERENCES_UPDATE"] = "USER_PREFERENCES_UPDATE";
    NotificationType["DO_NOT_DISTURB"] = "DO_NOT_DISTURB";
    NotificationType["INBOUND_BLOCKED_FAX_NOTIFICATION"] = "INBOUND_BLOCKED_FAX_NOTIFICATION";
})(NotificationType || (NotificationType = {}));
export var NotificationType_index;
(function (NotificationType_index) {
    NotificationType_index[NotificationType_index["UNKNOWN"] = 0] = "UNKNOWN";
    NotificationType_index[NotificationType_index["PHONE_CALL"] = 1] = "PHONE_CALL";
    NotificationType_index[NotificationType_index["SMS"] = 2] = "SMS";
    NotificationType_index[NotificationType_index["FOLLOW_UP"] = 3] = "FOLLOW_UP";
    NotificationType_index[NotificationType_index["VOICEMAIL"] = 4] = "VOICEMAIL";
    NotificationType_index[NotificationType_index["MISSED_CALL"] = 5] = "MISSED_CALL";
    NotificationType_index[NotificationType_index["FAX"] = 6] = "FAX";
    NotificationType_index[NotificationType_index["SCHEDULE_REQUEST"] = 7] = "SCHEDULE_REQUEST";
    NotificationType_index[NotificationType_index["CHAT_MESSAGE"] = 8] = "CHAT_MESSAGE";
    NotificationType_index[NotificationType_index["SMS_TAG"] = 9] = "SMS_TAG";
    NotificationType_index[NotificationType_index["REVIEWS"] = 10] = "REVIEWS";
    NotificationType_index[NotificationType_index["REVIEW_COMMENT"] = 11] = "REVIEW_COMMENT";
    NotificationType_index[NotificationType_index["FORMS"] = 12] = "FORMS";
    NotificationType_index[NotificationType_index["VOICEMAIL_TRANSCRIPTION"] = 13] = "VOICEMAIL_TRANSCRIPTION";
    NotificationType_index[NotificationType_index["PHONE_CALL_V2"] = 14] = "PHONE_CALL_V2";
    NotificationType_index[NotificationType_index["CALL_QUEUES"] = 15] = "CALL_QUEUES";
    NotificationType_index[NotificationType_index["SMS_PAUSE_SCHEDULED_THREAD"] = 16] = "SMS_PAUSE_SCHEDULED_THREAD";
    NotificationType_index[NotificationType_index["SMS_TAG_V2"] = 17] = "SMS_TAG_V2";
    NotificationType_index[NotificationType_index["PAYMENTS"] = 19] = "PAYMENTS";
    NotificationType_index[NotificationType_index["MANUAL_MESSAGE_CONSENT"] = 20] = "MANUAL_MESSAGE_CONSENT";
    NotificationType_index[NotificationType_index["TASK"] = 21] = "TASK";
    NotificationType_index[NotificationType_index["SMS_MANUAL_SCHEDULED"] = 22] = "SMS_MANUAL_SCHEDULED";
    NotificationType_index[NotificationType_index["FAX_READ_STATUS_CHANGE"] = 23] = "FAX_READ_STATUS_CHANGE";
    NotificationType_index[NotificationType_index["FAX_TAG"] = 24] = "FAX_TAG";
    NotificationType_index[NotificationType_index["DRAFT_COUNT_CHANGE"] = 25] = "DRAFT_COUNT_CHANGE";
    NotificationType_index[NotificationType_index["FAX_COUNT_CHANGE"] = 26] = "FAX_COUNT_CHANGE";
    NotificationType_index[NotificationType_index["CALL_RECORD"] = 27] = "CALL_RECORD";
    NotificationType_index[NotificationType_index["VOICEMAIL_TAG"] = 28] = "VOICEMAIL_TAG";
    NotificationType_index[NotificationType_index["CALL_RECORD_TAG"] = 29] = "CALL_RECORD_TAG";
    NotificationType_index[NotificationType_index["DEVICE_CONNECTION"] = 30] = "DEVICE_CONNECTION";
    NotificationType_index[NotificationType_index["TEAM_CHAT"] = 31] = "TEAM_CHAT";
    NotificationType_index[NotificationType_index["ORG_USER_PRESENCE"] = 33] = "ORG_USER_PRESENCE";
    NotificationType_index[NotificationType_index["VOICEMAIL_MESSAGE"] = 34] = "VOICEMAIL_MESSAGE";
    NotificationType_index[NotificationType_index["APPOINTMENT_CHANGED"] = 35] = "APPOINTMENT_CHANGED";
    NotificationType_index[NotificationType_index["SCHEDULE_CHANGED"] = 36] = "SCHEDULE_CHANGED";
    NotificationType_index[NotificationType_index["USER_PREFERENCES_UPDATE"] = 37] = "USER_PREFERENCES_UPDATE";
    NotificationType_index[NotificationType_index["DO_NOT_DISTURB"] = 38] = "DO_NOT_DISTURB";
    NotificationType_index[NotificationType_index["INBOUND_BLOCKED_FAX_NOTIFICATION"] = 39] = "INBOUND_BLOCKED_FAX_NOTIFICATION";
})(NotificationType_index || (NotificationType_index = {}));
export var NotificationDestination;
(function (NotificationDestination) {
    NotificationDestination["UNKNOWN_NOTIFICATION_DESTINATION"] = "UNKNOWN_NOTIFICATION_DESTINATION";
    NotificationDestination["ALL"] = "ALL";
    NotificationDestination["DESKTOP"] = "DESKTOP";
    NotificationDestination["MOBILE"] = "MOBILE";
})(NotificationDestination || (NotificationDestination = {}));
export var NotificationDestination_index;
(function (NotificationDestination_index) {
    NotificationDestination_index[NotificationDestination_index["UNKNOWN_NOTIFICATION_DESTINATION"] = 0] = "UNKNOWN_NOTIFICATION_DESTINATION";
    NotificationDestination_index[NotificationDestination_index["ALL"] = 1] = "ALL";
    NotificationDestination_index[NotificationDestination_index["DESKTOP"] = 2] = "DESKTOP";
    NotificationDestination_index[NotificationDestination_index["MOBILE"] = 3] = "MOBILE";
})(NotificationDestination_index || (NotificationDestination_index = {}));
